export default __webpack_public_path__ + "static/media/light_bulb_hint.13cb20e8.png";